import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedPostsView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/posts/applied_posts"]
  allowRemove: false
  alias: 'Posts'

  render: ->
    @$el.html(@template(
      fbPosts: @searchQuery.get('fb_posts')
      twitterPosts: @searchQuery.get('twitter_posts')
      instagramPosts: @searchQuery.get('instagram_posts')
      tiktokPosts: @searchQuery.get('tiktok_posts')
      linkedinPosts: @searchQuery.get('linkedin_posts')
      youtubePosts: @searchQuery.get('youtube_posts')
    ))
    @